import { useQuery } from "@apollo/client";
import { GET_WAREHOUSES, GET_WAREHOUSES_BY_SELLER } from "graphql/ware-house/query";

export const useWarehouse = (skip = false) => {
  const { data, loading } = useQuery(GET_WAREHOUSES, {
    skip,
  });

  const warehouseOptions = data?.warehouse?.list?.warehouses?.map(({ id, name, branch }) => ({
    value: id,
    label: `${branch?.name} - ${name}`,
  }));

  return {
    warehouses: data?.warehouse?.list?.warehouses,
    loading,
    warehouseOptions,
  };
};

export const usePickupWarehouses = (sellerID) => {
  const { data, loading } = useQuery(GET_WAREHOUSES_BY_SELLER, {
    variables: { sellerID },
    skip: !sellerID,
  });

  const allWarehouses = data?.warehouse?.list?.warehouses || [];
  const warehouses = allWarehouses.filter(
    (w) => w.type === "COMPANY_OWNED" && !w.name?.toLowerCase().includes("đà nẵng")
  );

  return { warehouses, loading };
};
